import { i18n } from '@/utils/i18n';

export const columns = {
    id: {
        show: true,
        title: "№",
        sortable: true,
        column: 'id'
    },
    title: {
        show: true,
        title:  i18n.t('message.name_0'),
        sortable: true,
        column: 'title'
    },
    from: {
        show: true,
        title:  i18n.t('message.from'),
        sortable: true,
        column: 'from'  
    },
    until: {
        show: true,
        title:   i18n.t('message.until'),
        sortable: true,
        column: 'until'
    },
   
    created_at: {
        show: true,
        title: i18n.t('message.date'),
        sortable: true,
        column: 'created_at'
    },
    updated_at: {
        show: false,
        title: i18n.t('message.update_date'),
        sortable: true,
        column: 'updated_at'
    },
    settings: {
        show: true,
        title: i18n.t('message.settings'),
        sortable: false,
        column: 'settings'
    }
};
